<template>
  <div>
    <h1>{{ $tc('word.user', 2) }}</h1>
    <form method="post">
      <div class="row">
        <div class="col-md-4">
          <div class="card card-body">
            <h5>{{ $t('word.gender') }}</h5>

            <v-check-box
              label="word.men"
              v-model="formData.filters.men"
              :errors="errors.men"
            />

            <v-check-box
              label="word.women"
              v-model="formData.filters.women"
              :errors="errors.women"
            />

            <hr/>

            <h5>{{ $t('word.activity') }}</h5>
            <v-check-box
              label="phrase.newsletter_only"
              help-text="sentence.newsletter_only_help_text"
              v-model="formData.filters.newsletter_only"
            />

            <v-check-box
              label="phrase.recently_inactive"
              help-text="sentence.recently_inactive_help_text"
              v-model="formData.filters.recently_inactive"
            />
            <hr/>

            <h5>{{ $t('word.age') }}</h5>
            <v-slider
              id="slider"
              v-model="age_range"
              @drag-end="getObjects()"
            />

            <div class="d-flex justify-content-between">
              <span>{{this.age_range[0]}}</span>
              <span>{{this.age_range[1]}}</span>
            </div>

            <hr/>
            <div class="text-center" v-if="totalObjects">
              {{ $t('word.total') }}:

              <div class="badge badge-info">
                <v-animated-number
                  :value="totalObjects"
                  :formatValue="(value) => (value.toFixed(0))"
                  :duration="500"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-8">
          <div class="card overflow-auto">
            <div class="d-flex justify-content-end p-2">
              <div class="mr-2">
                <v-button
                  type="button"
                  style-type="secondary"
                  size="sm"
                  @click="showMailModal = true"
                  icon="envelope"
                  text="phrase.send_email"
                />
              </div>
            </div>
            <table class="table table-hover">
              <thead>
              <tr>
                <th>{{ $t('word.username') }}</th>
                <th>{{ $t('word.name') }}</th>
                <th>{{ $t('word.coin_account') }}</th>
                <th>{{ $t('phrase.is_onboarded') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="(user, index) in objectList"
                :key="index"
                class="clickable"
                @click="$router.push({ name: 'admin-user-detail', params: { id: user.id } })"
              >
                <td>
                  {{ user.username }}
                </td>
                <td>
                  {{ user.full_name }}
                </td>
                <td>
                  <div v-if="user.coin_account">
                    {{ user.coin_account.rate }}
                    <div
                      v-title="$t('word.active')"
                      class="badge badge-success"
                      v-if="user.coin_account.is_active"
                    >
                      <i class="fa fa-check"></i>
                    </div>
                  </div>
                </td>
                <td>
                  <span v-if="user.is_onboarded"><i class="fa fa-check text-success"></i></span>
                  <span v-else><i class="fa fa-times text-danger"></i></span>
                </td>
              </tr>
              </tbody>
            </table>

            <div class="p-3 d-flex justify-content-center">
              <v-button
                text="phrase.load_more"
                v-if="nextPageUrl"
                style-type="secondary"
                size="xs"
                @click="getObjects(nextPageUrl, true)"
              />
            </div>
          </div>
        </div>
      </div>
    </form>

    <v-send-mail-modal
      v-if="showMailModal"
      :user-count="totalObjects"
      @hide-modal="showMailModal = false"
      @send-mail="sendMail"
    />
  </div>
</template>

<script>
import AnimatedNumber from 'animated-number-vue';
import Button from '@/common/components/Button.vue';
import CheckBox from '@/common/components/inputs/CheckBox.vue';
import { sendMail } from '@/admin/api';
import SendMailModal from '@/admin/components/SendMailModal.vue';
import { notify } from '@/common/utils/notify';
import { GenericListMixin } from '@/common/utils/mixins';
import VueSlider from 'vue-slider-component';

export default {
  name: 'UserList',
  components: {
    'v-animated-number': AnimatedNumber,
    'v-button': Button,
    'v-check-box': CheckBox,
    'v-send-mail-modal': SendMailModal,
    'v-slider': VueSlider,
  },
  methods: {
    async sendMail(mailData) {
      const response = await sendMail(mailData, this.getParams());
      if (response.status === 200) {
        this.showMailModal = false;
        notify(this.$t('sentence.email_sent'));
      } else {
        notify(this.$t('sentence.email_not_sent'), '', 'error');
      }
    },
    getParams() {
      const filter = {};
      if (this.filters.men || this.filters.women) {
        const genders = [];
        if (this.filters.men) {
          genders.push('m');
        }
        if (this.filters.women) {
          genders.push('f');
        }

        Object.assign(filter, { genders });
      }
      if (this.filters.newsletter_only) {
        Object.assign(filter, { newsletter_only: true });
      }

      if (this.filters.recently_inactive) {
        Object.assign(filter, { recently_inactive: true });
      }

      Object.assign(filter, { age_min: this.age_range[0] });
      Object.assign(filter, { age_max: this.age_range[1] });

      return filter;
    },
  },
  mixins: [GenericListMixin],
  data() {
    return {
      apiPath: 'admin/users/',
      formData: {
        subject: '',
        content: '',
        filters: {
          men: false,
          women: false,
          newsletter_only: false,
          recently_inactive: false,
        },
      },
      errors: {},
      downloadLoader: {
        loading: false,
      },
      showMailModal: false,
      userCount: 0,
      users: [],
      age_range: [0, 100],
    };
  },
  computed: {
    filters() {
      return this.formData.filters;
    },
  },
  watch: {
    filters: {
      handler() {
        this.getObjects();
      },
      deep: true,
    },
  },
};
</script>
